import { c as _c } from "react/compiler-runtime";
import { RefObject, useEffect } from 'react';
import { useResizeObserver } from 'usehooks-ts';
import { useLayoutContext } from '@/context/LayoutContext';
export const useCalculateHeaderHeight = headerRef => {
  const $ = _c(13);
  const {
    setHeaderHeight,
    setLogoHeight
  } = useLayoutContext();
  const t0 = headerRef as RefObject<HTMLElement>;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      ref: t0,
      box: "border-box"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    height: t2
  } = useResizeObserver(t1);
  const headerHeight = t2 === undefined ? 0 : t2;
  let t3;
  let t4;
  if ($[2] !== headerHeight || $[3] !== setHeaderHeight) {
    t3 = () => {
      if (headerHeight > 0) {
        setHeaderHeight(headerHeight);
      }
    };
    t4 = [headerHeight, setHeaderHeight];
    $[2] = headerHeight;
    $[3] = setHeaderHeight;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== headerRef || $[7] !== setLogoHeight) {
    t5 = () => {
      if (!headerRef.current) {
        return;
      }
      const nav = headerRef.current.querySelector("nav");
      const candidate = nav?.firstElementChild;
      if (!(candidate instanceof HTMLElement)) {
        return;
      }
      const observer = new ResizeObserver(t6 => {
        const [entry] = t6;
        setLogoHeight(Math.round(entry.contentRect.height));
      });
      observer.observe(candidate);
      return () => observer.disconnect();
    };
    $[6] = headerRef;
    $[7] = setLogoHeight;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== headerHeight || $[10] !== headerRef || $[11] !== setLogoHeight) {
    t6 = [headerRef, setLogoHeight, headerHeight];
    $[9] = headerHeight;
    $[10] = headerRef;
    $[11] = setLogoHeight;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
};